"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenValidationError = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _ModalTypes = require("../../../constants/ModalTypes");
var _Refresh = require("../../../components/Modals/Refresh");
var TokenValidationError = exports.TokenValidationError = function TokenValidationError() {
  var isOpen = (0, _reactRedux.useSelector)(function (state) {
    var _state$modal;
    return ((_state$modal = state.modal) === null || _state$modal === void 0 ? void 0 : _state$modal.type) === _ModalTypes.VALIDATE_USER_TOKEN_ERROR;
  });
  return /*#__PURE__*/_react["default"].createElement(_Refresh.RefreshModal, {
    isOpen: isOpen,
    title: 'You’re logged in to another Studio',
    buttonText: 'Ok'
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "You are currently logged into studio in another tab. You can only be logged into one studio instance at a time.")));
};
TokenValidationError.propTypes = {};